















import Vue from "vue";
export default Vue.extend({
  name: "MultichoiceQuestion",

  props: {
    question: {
      type: Object,
      required: true
    }
  },

  components: {
    MultichoiceAnswer: () => import("./MultichoiceAnswer.vue")
  }
});
